import * as bootstrap from 'bootstrap';
import "../imagepaths";
import "../css/style.css";
import "../css/addonclass.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import swal2 from "sweetalert2";
window.Modal = bootstrap.Modal;
window.swal2 = swal2;
window.toast = toast;